<template>
  <div class="w-100">
    <div v-if="type == null">
      <b-form-select
        :options="members"
        v-if="!isLoadingMember"
        v-on="$listeners"
        v-model="selectedMember"
        :state="state"
      ></b-form-select>
    </div>
    <div v-else> 
      <v-select
        :options="members"
        v-if="!isLoadingMember"
        v-on="$listeners"
        v-model="selectedMember"
        :state="state"
        value="value"
        label="text"
        
        @input="onchanged"
      ></v-select>
    </div>
   
    <b-skeleton v-if="isLoadingMember" type="input" width="100%"></b-skeleton>
    <b-form-invalid-feedback v-if="errorMessage">
      {{ errorMessage }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import {lookupMember} from "@/services/members";
import "vue-select/dist/vue-select.css";

export default {
  name: "MemberDropDown",
  props:{
    type:null,
    member: {
      type: Object,
    },
    errorMessage: {
      type: String,
    },
    state:null,
    showSuperAdmin: {
      type: Boolean,
      default: false,
    },
    showAllMembers: {
      type: Boolean,
      default: false,
    },
  },
  data:()=>({
    isLoadingMember: false,
    members: [
      { value: null, text: 'Super Administrator'},
    ],
    selectedMember: null,
  }),
  methods:{
    async loadMembers() {
      try {
        this.isLoadingMember = true;
        const {data: {data: {rows}}} = await lookupMember();
        const members = Array.isArray(rows.member) ? rows.member : [rows.member];
        this.members = (members.map(({id, company_name}) => ({value: {id, company_name}, text: company_name.length > 35 ? company_name.substring(0,35)+' ...': company_name})));
        if (this.showSuperAdmin) {
          this.members.unshift(
              { value: null, text: 'Super Administrator'}
          )
        }
        if (this.showAllMembers) {
          this.members.unshift(
              { value: '', text: 'All Members'}
          )
        }
        this.$emit('update:members', this.members)
      } catch (e) {
        this.members = [
          { value: null, text: 'Super Administrator'},
        ];
      }
      this.isLoadingMember = false;
    },
    async onchanged(val){
      this.$emit("change", val);
      console.log("onchange");
    }
  },
  async mounted() {
    await this.loadMembers();
    if (this.member) {
      this.selectedMember = this.member
    }
    if (this.type == null) {
      // console.log("type null");
    }else{
      // console.log("type not null");
      
    }
  },
}
</script>


